/**
 * Percoustix Shopify Theme JS
 */

(function() {
  'use strict';

  // Cart drawer functionality
  var cartDrawer = document.querySelector('.cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Cart icon click
  var cartLink = document.querySelector('.nav-cart');
  if (cartLink) {
    cartLink.addEventListener('click', function(e) {
      if (cartDrawer) {
        e.preventDefault();
        openCartDrawer();
      }
    });
  }

  // Close button
  var closeBtn = document.querySelector('.cart-drawer__close');
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);

  // Overlay click
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  // Active nav link highlighting
  var currentPath = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(function(link) {
    if (link.getAttribute('href') === currentPath) {
      link.classList.add('active');
    }
  });

})();
